// Calendário da recompensa diária: uma por dia do mês, pega em sequência (uma por dia).
// CSS em client/css-parts/store.css (prefixo .dy-).
import { useState } from 'preact/hooks';
import { DAILY, dailyLabel } from '../../../../shared/src/game/daily';
import { EXERCISE_KINDS } from '../../../../shared/src/game/store';
import type { VocationId } from '../../../../shared/src/game/vocations';

const ICON: Record<string, number> = { stokens: 22516, gtokens: 22721, exercise: 28552, xpboost: 11510, bless: 3214, gold: 3043, coins: 22118 };
const defaultEx = (v: VocationId) => (v === 'knight' ? 'sword' : v === 'paladin' ? 'bow' : v === 'sorcerer' ? 'wand' : v === 'druid' ? 'rod' : 'wraps');

export function Daily(props: { claimed: number; canClaim: boolean; level: number; vocation: VocationId; xpBoostUntil: number; onClaim: (potion: string, exercise: string) => void; Img: (p: { typeId: number; count: number }) => preact.JSX.Element | null }) {
  const potion = 'health';   // (as poções saíram das recompensas)
  const [ex, setEx] = useState(defaultEx(props.vocation));
  const [help, setHelp] = useState(false);
  const next = DAILY[props.claimed];
  const boost = props.xpBoostUntil > Date.now() ? Math.ceil((props.xpBoostUntil - Date.now()) / 60000) : 0;
  const icon = (r: (typeof DAILY)[number]) => (r.kind === 'preycards' ? <img class="store-img" src="/assets/interface/images/prey-wildcards-icon.png" alt="" title="Prey Cards" /> : r.kind === 'fragments' ? <span class="rw-frag" title="Fragmentos de pedra de proteção">💠</span> : <props.Img typeId={ICON[r.kind]!} count={r.kind === 'coins' ? 100 : 1} />);
  // próximo prêmio grande depois de hoje
  const bigAt = DAILY.findIndex((r, i) => i > props.claimed && r.big);
  const showHelp = help || props.claimed === 0;
  return (
    <div class="dy">
      <div class="dy-head">
        <div class="dy-cal" aria-hidden="true"><small>Dia</small><b>{Math.min(props.claimed + (props.canClaim ? 1 : 0), DAILY.length) || 1}</b></div>
        <div class="dy-head-txt">
          <div class="dy-title">Recompensa diária <button class={'dy-help' + (showHelp ? ' on' : '')} onClick={() => setHelp(!help)} title="Como funciona">?</button></div>
          <div class="dy-prog">
            <span class="dy-bar"><i style={{ width: `${(props.claimed / DAILY.length) * 100}%` }} /></span>
            <span><b>{props.claimed}</b>/{DAILY.length} pegas este mês</span>
          </div>
          <div class="dy-chips">
            {props.canClaim ? <span class="dy-chip hot">🎁 Recompensa de hoje liberada</span> : next ? <span class="dy-chip">🌙 Volte amanhã</span> : null}
            {bigAt >= 0 && <span class="dy-chip gold" title={dailyLabel(DAILY[bigAt]!, props.level)}>⭐ Prêmio grande em {bigAt - props.claimed + (props.canClaim ? 0 : 1)} {bigAt - props.claimed + (props.canClaim ? 0 : 1) === 1 ? 'dia' : 'dias'}</span>}
            {boost > 0 && <span class="dy-chip xp">⚡ Boost de XP: {boost} min</span>}
          </div>
        </div>
      </div>
      {showHelp && (
        <div class="dy-steps">
          <div><i>📅</i><b>Uma por dia</b><small>Cada dia em que você entra, pega a próxima do calendário, em sequência.</small></div>
          <div><i>⭐</i><b>Dias dourados</b><small>Os dias com borda dourada dão prêmios maiores.</small></div>
          <div><i>📦</i><b>Store Box</b><small>Os itens vão para a Store Box e ficam presos ao personagem. O calendário recomeça todo mês.</small></div>
        </div>
      )}
      <div class="dy-grid">
        {DAILY.map((r, i) => {
          const st = i < props.claimed ? ' done' : i === props.claimed ? (props.canClaim ? ' today' : ' wait') : ' later';
          return (
            <div key={i} class={'dy-day' + st + (r.big ? ' big' : '')} title={dailyLabel(r, props.level)}>
              <span class="dy-n">{i + 1}</span>
              <span class="item-slot">{icon(r)}</span>
              <span class="dy-l">{dailyLabel(r, props.level)}</span>
              {i === props.claimed && <span class="dy-flag">{props.canClaim ? 'HOJE' : 'AMANHÃ'}</span>}
            </div>
          );
        })}
      </div>
      {next ? (
        <div class={'dy-claim' + (props.canClaim ? ' on' : '')}>
          <span class="dy-claim-ico"><span class="item-slot">{icon(next)}</span></span>
          <div class="dy-claim-txt"><small>{props.canClaim ? 'Hoje' : 'Próxima (amanhã)'}</small><b>{dailyLabel(next, props.level)}</b></div>
          {next.kind === 'exercise' && (
            <select class="dy-sel" value={ex} onChange={(e) => setEx((e.target as HTMLSelectElement).value)}>
              {EXERCISE_KINDS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select>
          )}
          <button class="tb-button green" disabled={!props.canClaim} onClick={() => props.onClaim(potion, ex)}>{props.canClaim ? 'Pegar recompensa' : 'Volte amanhã'}</button>
        </div>
      ) : <p class="dy-allset">🏆 Você pegou todas as recompensas deste mês!</p>}
    </div>
  );
}
